import { FluxStandardAction as Action } from "flux-standard-action";
import { MERCHANT } from "constants/action-types";
import { SetupStepName } from "containers/admin/settings/merchant-admin-settings";
import { ISetupSteps } from "constants/merchant";

export type GetMerchantSetupStepsRequestAction = Action<
    {
        merchantId: string;
    },
    {}
>;
export const getMerchantSetupStepsRequest = (merchantId: string): GetMerchantSetupStepsRequestAction => ({
    meta: {},
    payload: { merchantId },
    type: MERCHANT.SETUP_STEPS.GET.REQUEST,
});

export type GetMerchantSetupStepsCompleteAction = Action<ISetupSteps[] | Error, {}>;
export const getMerchantSetupStepsComplete = (payload: ISetupSteps[] | Error): GetMerchantSetupStepsCompleteAction => ({
    meta: {},
    payload: payload,
    error: payload instanceof Error,
    type: MERCHANT.SETUP_STEPS.GET.COMPLETE,
});

export type PutMerchantSetupStepsRequestAction = Action<
    {
        name: SetupStepName;
        merchantId: string;
    },
    {}
>;

export const putMerchantSetupStepsRequest = (
    name: SetupStepName,
    merchantId: string
): PutMerchantSetupStepsRequestAction => ({
    meta: {},
    payload: { name, merchantId },
    type: MERCHANT.SETUP_STEPS.PUT.REQUEST,
});

export type PutMerchantSetupStepsCompleteAction = Action<ISetupSteps | Error, {}>;

export const putMerchantSetupStepsComplete = (payload: ISetupSteps | Error): PutMerchantSetupStepsCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.SETUP_STEPS.PUT.COMPLETE,
});
